import { fetchRelatedProducts } from "~/ProductDetails/api/fetchRelatedProducts";
import type { RootState } from "~/redux/store";
import type { AnyAction } from "~/redux/types";
import type { ThunkAction } from "redux-thunk";
import type { ProductData } from "~/models/ProductData";

type ThunkResult<R> = ThunkAction<R, RootState, undefined, AnyAction>;

export type RelatedProductsActions = ReturnType<typeof startFetchRelatedProducts | typeof finishFetchRelatedProducts>;

export const START_FETCH_RELATED_PRODUCTS = "PDP: Start Fetch Related products";
export const FINISH_FETCH_RELATED_PRODUCTS = "PDP: Finish Fetch Related products";

export const startFetchRelatedProducts = (productCode: string) => {
  return { type: START_FETCH_RELATED_PRODUCTS, payload: { productCode } } as const;
};

export const finishFetchRelatedProducts = (productCode: string, relatedProducts: ProductData[], error: boolean) => {
  return { type: FINISH_FETCH_RELATED_PRODUCTS, payload: { productCode, relatedProducts, error } } as const;
};

export const fetchRelatedProductsThunk = (productCode: string): ThunkResult<Promise<void>> => {
  return async (dispatch, getState) => {
    const state = getState();
    const loadingStatus = state.products.relatedProducts[productCode];
    if (loadingStatus?.state === "loading" || loadingStatus?.state === "loaded") {
      return;
    }

    dispatch(startFetchRelatedProducts(productCode));
    try {
      const relatedProducts = await fetchRelatedProducts(productCode);
      dispatch(finishFetchRelatedProducts(productCode, relatedProducts, false));
    } catch (error) {
      console.error(error);
      dispatch(finishFetchRelatedProducts(productCode, [], true));
    }
  };
};
